import React, { useState, useEffect, useMemo } from "react";
import "../assets/lotto.css";

const COLUMNS = [
  { key: "name", label: "Game" },
  { key: "cost", label: "Cost" },
  { key: "topPrize", label: "Top Prize" },
  { key: "soldPct", label: "Sold %" },
  { key: "topClaimed", label: "Claimed" },
  { key: "topTotal", label: "Total" },
  { key: "overdue", label: "Overdue" },
];

const Lotto = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [sortKey, setSortKey] = useState("overdue");
  const [sortDir, setSortDir] = useState("desc");

  useEffect(() => {
    fetch("/data/iowa-scratch.json")
      .then((r) => {
        if (!r.ok) throw new Error(String(r.status));
        return r.json();
      })
      .then((d) => setData(d))
      .catch((e) => setError(e.message));
  }, []);

  const games = useMemo(() => {
    if (!data || !data.games) return [];
    const arr = [...data.games];
    arr.sort((a, b) => {
      const va = a[sortKey];
      const vb = b[sortKey];
      let cmp;
      if (typeof va === "string") cmp = va.localeCompare(vb);
      else cmp = (va ?? 0) - (vb ?? 0);
      return sortDir === "asc" ? cmp : -cmp;
    });
    return arr;
  }, [data, sortKey, sortDir]);

  const toggleSort = (key) => {
    if (sortKey === key) setSortDir((d) => (d === "asc" ? "desc" : "asc"));
    else {
      setSortKey(key);
      setSortDir("desc");
    }
  };

  if (error) return <div className="lotto-note">Couldn't load scratch data.</div>;
  if (!data) return <div className="lotto-note">Loading scratch data…</div>;

  return (
    <section className="lotto">
      <h2>Iowa Scratch — Top Prize Watch</h2>
      <p className="lotto-updated">
        {data.generated
          ? `Last updated ${new Date(data.generated).toLocaleDateString(undefined, {
              month: "short",
              day: "numeric",
              year: "numeric",
            })}`
          : ""}
      </p>
      <p className="lotto-sub">
        Games ranked by how overdue their top prizes are (higher = more due). Click a column to sort.
      </p>

      <div className="lotto-wrap">
        <table className="lotto-table">
          <thead>
            <tr>
              {COLUMNS.map((c) => (
                <th
                  key={c.key}
                  onClick={() => toggleSort(c.key)}
                  className={sortKey === c.key ? "active" : ""}
                >
                  {c.label}
                  {sortKey === c.key ? (sortDir === "asc" ? " ▲" : " ▼") : ""}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {games.map((g) => (
              <tr key={g.name} className={g.overdue > 1 ? "hot" : ""}>
                <td className="name">{g.name}</td>
                <td>${g.cost}</td>
                <td className="money">${g.topPrize.toLocaleString()}</td>
                <td>{g.soldPct}%</td>
                <td>{g.topClaimed}</td>
                <td>{g.topTotal}</td>
                <td className={"overdue" + (g.overdue > 0 ? " pos" : "")}>
                  {g.overdue.toFixed(2)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p className="lotto-foot">
        Data: Iowa Lottery remaining prizes — top prizes $50k+, ≥10% sold. "Overdue" = expected jackpot hits minus actual.
      </p>
    </section>
  );
};

export default Lotto;
